import React, { useMemo } from 'react';
import { Banner, Text, Box } from '@shopify/polaris';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePlanCheck } from '../hooks/usePlanCheck';

export const PlanUpgradeBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { planData } = usePlanCheck();

  const isPricingPage = useMemo(() => location?.pathname === '/pricing', [location?.pathname]);
  const isFreePlan = planData?.plan_type === 'free';

  if (!planData || !isFreePlan || isPricingPage) {
    return null;
  }

  return (
    <Box paddingBlockStart="400" paddingInline="400">
      <Banner
        title="Upgrade to unlock more rules and products"
        tone="warning"
        action={{
          content: 'Upgrade plan',
          onAction: () => navigate('/pricing')
        }}
      >
        <Text variant="bodyMd">
          You are on the Free plan. Upgrade to create unlimited rules and apply pricing to more products.
        </Text>
      </Banner>
    </Box>
  );
};
